var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1537 27.7666C30.5368 26.5085 31.666 24.9763 32.4557 23.2558H33.8832C42.1421 23.2558 48.8373 29.951 48.8373 38.21V44.186L40.6976 44.186C40.6976 36.6232 35.8842 30.1845 29.1537 27.7666ZM30.2326 0C26.9073 0 23.9079 1.39589 21.7886 3.63368C28.5371 4.61289 33.7209 10.422 33.7209 17.4418C33.7209 19.4262 33.3067 21.3138 32.56 23.0228C37.8666 21.9448 41.8605 17.2528 41.8605 11.6279C41.8605 5.20599 36.6545 0 30.2326 0ZM31.3954 17.4419C31.3954 23.8638 26.1894 29.0698 19.7675 29.0698C13.3456 29.0698 8.13958 23.8638 8.13958 17.4419C8.13958 11.02 13.3456 5.81398 19.7675 5.81398C26.1894 5.81398 31.3954 11.02 31.3954 17.4419ZM0 44.024C0 35.765 6.69521 29.0698 14.9542 29.0698H23.4179C31.6769 29.0698 38.3721 35.765 38.3721 44.024V50H0V44.024Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d9f4482596b382ba758d0ee3d08181c0.svg";
export { ForwardRef as ReactComponent };